import { useQuery } from "@tanstack/react-query";

import { aguardandoEntregaService } from "../services/aguardandoEntregaService";

export const useAguardandoEntregaList = (
  lojaId: number | undefined,
  displayId?: string,
  orderId?: string,
  options?: {
    refetchInterval?: number | false;
    refetchOnWindowFocus?: boolean;
  }
) => {
  return useQuery({
    queryKey: ["aguardando-entrega", lojaId, displayId ?? "", orderId ?? ""],
    queryFn: () => aguardandoEntregaService.listar(lojaId!, displayId, orderId),
    enabled: !!lojaId,
    refetchInterval: options?.refetchInterval ?? 10_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });
};
